module.exports = __webpack_public_path__ + "img/PRCA1_CD8T.30db33e1.png";